import { render } from "./contractDetailSwitchCard.vue?vue&type=template&id=08a18e4f&scoped=true&ts=true"
import script from "./contractDetailSwitchCard.vue?vue&type=script&lang=ts"
export * from "./contractDetailSwitchCard.vue?vue&type=script&lang=ts"

import "./contractDetailSwitchCard.vue?vue&type=style&index=0&id=08a18e4f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a18e4f"]])

export default __exports__